<template>
    <div v-if="visible">
        <Button class="border-round-xl go-back-btn" @click="emit('click')">
            <i class="pi pi-angle-left"></i><span class="ml-2">Back</span>
        </Button>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const emit = defineEmits(['click'])
const route = useRoute();

// Reactive off the route so it updates on SPA navigation (the old
// window.location check never re-evaluated without a full page reload).
const visible = computed(() => {
    const link = route.query.link;
    const linkParam = Array.isArray(link) ? link[0] : link;
    return linkParam && linkParam !== '' && linkParam != 'undefined';
});
</script>

<style lang="scss" scoped>
.go-back-btn>span {
    font-size: 1.7rem !important;
    font-weight: 900;
}

.go-back-btn>.pi:before {
    font-size: 2.5rem !important;
    font-weight: 900;
}

.go-back-btn,
.clear-all-btn {
    color: #ffffff !important;
}

.go-back-btn {
    min-height: 3.75rem;
    padding: 0.5rem 1.5rem !important;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.18);
    transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
}

.go-back-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.24);
}

.go-back-btn:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    filter: brightness(0.94);
}
</style>